import { appClick } from './appClick';
import { resumeView } from './resumeView';
import { themeChange } from './themeChange';

export const events = {
	resumeView,
	themeChange,
	appClick,
};
